import PropTypes from 'prop-types';

import { makeComponentHeading } from 'helpers/LandingPageUtils';
import MelodyCarousel from 'components/common/MelodyCarousel.jsx';
import SmallProductCard from 'zen/components/common/SmallProductCard';

import css from 'styles/components/common/productCarousel.scss';

const imgDimensions = 211;
const type = 'flexv';

const ProductCarousel = ({ slotName, slotDetails, onProductClick }, { testId }) => {
  const { products, title } = slotDetails;
  const classes = { itemsContainer: css.itemsContainer };

  return (
    <div data-test-id={testId('productCarousel')} className={css.productCarousel} data-slot-id={slotName}>
      {makeComponentHeading({ heading: title })}
      <MelodyCarousel classes={classes}>
        {products.map((product, i) => <SmallProductCard
          index={i}
          key={`${product.styleId}-${i}`}
          cardData={product}
          onClick={onProductClick}
          type={type}
          msaImageDimensions={imgDimensions}
          threeSixtyDimensions={imgDimensions}/>)}
      </MelodyCarousel>
    </div>
  );
};

ProductCarousel.contextTypes = {
  testId: PropTypes.func
};

export default ProductCarousel;
